/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

export default function Stats({ data }) {
  return (
    <section className="container mx-auto px-4 lg:px-8 py-12 relative z-10">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <span className="section-eyebrow">Our Impact</span>
        </div>
        <div className="stats-band">
          {data.map((item) => (
            <div key={item.label} className="stat-card">
              <div className="stat-value">{item.value}</div>
              <div className="stat-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
